import type { CollectionUUID } from '@library/menu-service'

import type { Collection, MenuCollectionsState } from 'reducers/menu-collections/menuCollections'

// It's never actually returned, because menuV3Collections exists even in the initial state
const NO_COLLECTIONS: Record<CollectionUUID, Collection> = {}

export const getCollections = ({ menuV3Collections }: MenuCollectionsState) =>
  menuV3Collections?.collections || NO_COLLECTIONS
